import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ErrorStateFallback } from '@/components/ui/error-state';
import { useJobPostingContext } from '@/contexts/job-posting-context';

import { Header } from './header';
import { JobPostingFlow } from './job-posting-flow';

export function JobPosting() {
  const location = useLocation();
  const { handlePostJob, clearJobPostingStorage } = useJobPostingContext();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    void handlePostJob();
  };

  // Clear storage when user navigates away from /post-job route. This won't trigger on page refresh since the component remounts with the same location
  useEffect(() => {
    return () => {
      if (!window.location.pathname.includes('/post-job')) {
        clearJobPostingStorage();
      }
    };
  }, [location, clearJobPostingStorage]);

  return (
    <ErrorStateFallback>
      <form onSubmit={handleSubmit}>
        <div className="flex h-screen flex-col gap-4">
          <Header />

          <JobPostingFlow />
        </div>
      </form>
    </ErrorStateFallback>
  );
}
